import { unseenTasksCount } from '../../store/reselectors/filteredTasks.reselector';
import { OnInit, EventEmitter, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { toggleFilterTypes, FilterType, filterActions } from '../../store/filters.era'
import { Component, Input } from '@angular/core'
import { loadLocal, saveLocal } from 'src/app/helpers/helpers';
import { Wrapper } from '../wrapper.component';
import { MatMenuModule } from '@angular/material/menu';
import { CommonModule } from '@angular/common';
import { IconComponent } from '../icon/icon.component';

@Component({
    selector: 'app-task-toggle-menu',
    templateUrl: './task-toggle-menu.html',
    styleUrls: ['task-toggle-menu.scss'],
    standalone: true,
    imports: [MatMenuModule, CommonModule, IconComponent],
})
export class TaskToggleMenuComponent extends Wrapper<TaskToggleMenuComponent> implements OnInit {

  public hideCompleted: boolean
  public sortByDate: boolean
  public condensedView: boolean
  public unseenTasksCount: number

  @Input() lightDots: boolean = false
  @Input() filterPage: FilterType
  @Input() showSortOptions: boolean = true
  @Input() showDetailOptions: boolean = true
  @Input() showMarkAllRead: boolean = true
  @Input() showHideTasks: boolean = true

  @Input() showExport: boolean = false
  @Output() onExport: EventEmitter<void> = new EventEmitter()
  @Input() showImport: boolean = false
  @Output() onImport: EventEmitter<void> = new EventEmitter()
  
  ngOnInit() {

    this.selectProp(unseenTasksCount, null, 'unseenTasksCount')
    this.subProp(this.store.select('filters', 'toggleFilters', this.filterPage, toggleFilterTypes.sortByDate ), 'sortByDate')
    this.subProp(this.store.select('filters', 'toggleFilters', this.filterPage, toggleFilterTypes.condensed ), 'condensedView')
    this.subProp(this.store.select('filters', 'toggleFilters', this.filterPage, toggleFilterTypes.hideCompleted ), 'hideCompleted')

    Object.values(toggleFilterTypes).forEach(toggleFilterType => {
      const defaultValue = toggleFilterType === 'hideCompleted' && this.filterPage === 'allTasks' ? true : false
      const savedToggle = loadLocal(`${this.filterPage}:${toggleFilterType}`, defaultValue) // 0 is returned if value is not in local storage
      if (savedToggle !== 0) {
        this.store.dispatch(filterActions.setFilterBoolean({ filterGroup: this.filterPage, booleanFilter: toggleFilterType, value: savedToggle }))
      }
    })

  }

  saveToggleToLocalStorage(toggleFilterType: string, value: boolean) {
    saveLocal(`${this.filterPage}:${toggleFilterType}`, value)   
  }

  toggleCompletedTasks() {
    this.saveToggleToLocalStorage(toggleFilterTypes.hideCompleted, !this.hideCompleted)
    this.store.dispatch(filterActions.toggleFilterBoolean({ filterGroup: this.filterPage, booleanFilter: toggleFilterTypes.hideCompleted }))
  }
  toggleView() {
    this.saveToggleToLocalStorage(toggleFilterTypes.condensed, !this.condensedView)
    this.store.dispatch(filterActions.toggleFilterBoolean({ filterGroup: this.filterPage, booleanFilter: toggleFilterTypes.condensed }))   
  }
  toggleSort() {
    this.saveToggleToLocalStorage(toggleFilterTypes.sortByDate, !this.sortByDate)
    this.store.dispatch(filterActions.toggleFilterBoolean({ filterGroup: this.filterPage, booleanFilter: toggleFilterTypes.sortByDate }))
  }



}
